import { groupBy } from 'lodash';
import { unreadConversations } from './inbox.state';
import type { Conversation } from '/@/modules/messenger/_modules/conversation/models/Conversation';

export function getUnreadConversationsByEstate(): Record<string, Conversation[]> {
  return (
    groupBy(unreadConversations.value, (conversation: Conversation) => conversation.estateId) ?? {}
  );
}

export function getUnreadConversationsByUser(): Record<string, Conversation[]> {
  return (
    groupBy(
      unreadConversations.value,
      (conversation: Conversation) => conversation.lastMessage?.userId
    ) ?? []
  );
}

export function getUnreadConversations(): Conversation[] {
  return unreadConversations.value;
}

export function getUnreadConversationsCount(estateId: number): number {
  return unreadConversations.value.filter((conversation: Conversation) =>
    conversation.isRelatedToEstate(estateId)
  ).length;
}
